import { Button } from "../button/Button.js";
import "../button/index.js";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from "@radix-ui/react-popover";
//#region src/popover/Popover.tsx
const PopoverContent = ({ className, children, ...rest }) => {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Content, {
		className: twMerge(`z-pentOutermost rounded-xl bg-white shadow-popover`, className),
		...rest,
		children
	});
};
const PopoverArrow = ({ className, ...rest }) => {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Arrow, {
		className: twMerge("fill-white", className),
		...rest
	});
};
const PopoverClose = ({ className, children, "aria-label": ariaLabel, ...rest }) => {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Close, {
		className: twMerge("z-pentOutermost", className),
		asChild: true,
		...rest,
		children: /* @__PURE__ */ jsx(Button, {
			variant: "none",
			"aria-label": ariaLabel ?? "Close",
			children: children || /* @__PURE__ */ jsx(FontAwesomeIcon, {
				size: "lg",
				icon: faClose,
				className: "text-gray-500"
			})
		})
	});
};
const PopoverRoot = PopoverPrimitive.Root;
const PopoverPortal = PopoverPrimitive.Portal;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const Root = PopoverRoot;
const Portal = PopoverPortal;
const Trigger = PopoverTrigger;
const Anchor = PopoverAnchor;
const Content = PopoverContent;
const Close = PopoverClose;
const Arrow = PopoverArrow;
//#endregion
export { Anchor, Arrow, Close, Content, PopoverAnchor, PopoverArrow, PopoverClose, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger, Portal, Root, Trigger };
